// /apply and /intake used to render full forms that silently DISCARDED every
// submission (COM-770 — handleSubmit was preventDefault + alert). The
// canonical intake is the external application form on v2, so these routes
// now hand off there with attribution intact, counting the handoff as the
// lead conversion before leaving.
import React, { useEffect } from 'react';
import { APPLY_FORM_URL, fireApplyHandoffConversion, withAttribution } from '../lib/attribution';
import SEO from '../components/SEO';

const ExternalApplyRedirect: React.FC = () => {
  const url = withAttribution(APPLY_FORM_URL);
  useEffect(() => {
    fireApplyHandoffConversion('apply_route_redirect');
    // Give gtag a beat to flush, then hand off (replace: no back-button trap).
    const t = setTimeout(() => window.location.replace(url), 400);
    return () => clearTimeout(t);
  }, [url]);
  return (
    <div style={{ padding: '4rem 1rem', textAlign: 'center' }}>
      {/* noindex: this is a redirect, not a page. /apply was drawing 164
          impressions at position 21 over 90 days and converting none of them —
          impressions the real pages could have had. */}
      <SEO
        title="Application form — Commissary Connect"
        description="Redirecting to the Commissary Connect application form."
        noindex
      />
      <p>Taking you to the application form…</p>
      <a href={url}>Continue to the application form</a>
    </div>
  );
};

export default ExternalApplyRedirect;
